import React, { useState } from 'react';
import { process } from '@progress/kendo-data-query';
import {
  Grid,
  GridColumn,
  GridColumnMenuFilter,
} from '@progress/kendo-react-grid';
import { ITimeUsageReport } from '../../models/TimeUsageReport.model';
import ColumnMenu from '../shared/ColumnMenu';
import { IFraction } from '../../models/Fraction.model';
import { locale } from '../../common/localization/localizationService';
import { diffTime } from '../../utils/GeneralUtils';

export interface ITimeUsageReportGridProps {
  data: Array<ITimeUsageReport>;
  fractions: Array<IFraction>;
}

export default function TimeUsageReportGrid(
  props: ITimeUsageReportGridProps,
): JSX.Element {
  const [dataState, setDataState] = useState({
    sort: [{ dir: 'asc', field: 'orderDate' }],
    take: 26,
    skip: 0,
  });
  const dataStateChange = (event: any) => {
    setDataState(event.data);
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };
  const isColumnActive = (field: string, dataState: any) => {
    return GridColumnMenuFilter.active(field, dataState.filter);
  };
  const gridData = props.data.map((order) => {
    order.fractionIdList = order.fractionIds.split(',').map((x) => Number(x));
    order.downloadTime = new Date(order.downloadTime);
    order.firstSigned = new Date(order.firstSigned);
    order.lastSigned = new Date(order.lastSigned);
    order.orderDate = new Date(order.orderDate);
    order.routeData = { name: order.routeName };
    order.fractions = [];
    order.fractionIdList.forEach((id) => {
      const foundFraction = props.fractions.find(
        (fraction) => fraction.fractionId === id,
      );
      if (foundFraction) {
        order.fractions.push(foundFraction);
      }
    });
    order.effectiveTime = diffTime(order.firstSigned, order.lastSigned);
    order.usageTime = diffTime(order.downloadTime, order.lastSigned);
    return order;
  });

  const result = process(gridData, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className="time-usage-report-grid filter-open"
        data={result}
        selectedField="selected"
        pageable
        resizable
        pageSize={26}
        onDataStateChange={dataStateChange}
        sortable
      >
        <GridColumn
          {...columnProps('routeName')}
          title={locale.timeUsageReport._orderName}
          sortable
        />
        <GridColumn
          {...columnProps('orderDate')}
          title={locale.timeUsageReport._orderDate}
          sortable
          format={'{0:' + locale.general._fullDateFormat + '}'}
        />
        <GridColumn
          {...columnProps('effectiveTime')}
          title={locale.timeUsageReport._effectiveTime}
          sortable
        />
        <GridColumn
          {...columnProps('usageTime')}
          title={locale.timeUsageReport._usageTime}
          sortable
        />
        <GridColumn
          title={locale.timeUsageReport._fractions}
          cell={(gridProps: any) => (
            <td>
              {gridProps.dataItem.fractions &&
                gridProps.dataItem.fractions
                  .filter(
                    (frac: any, index: any, self: any) =>
                      index ===
                      self.findIndex((t: any) => t.name === frac.name),
                  ) // This ensures each name appears only once
                  .map((frac: any) => <div key={frac.name}>{frac.name}</div>)}
            </td>
          )}
        />
      </Grid>
    </>
  );
}
